import { usePaymentMonth } from '../month-scope';
import { generatePath, useOutletContext } from 'react-router-dom';

import { PayoutType } from 'types';
import { mapQuery } from 'utils/query';
import { Messages, AppRoutes } from 'config';
import { TransactionsList } from 'components';
import { Payout, useListQuery, useDeleteMutation } from 'store/api/payout';
import {
  isMobile,
  useFilter,
  useShowMore,
  useNavigate,
  useSearchQuery,
  handleMutation,
} from 'hooks';

import { OutletContext } from '../../types';
import {
  getCommonListProps,
  advanceBonusCellsMobile,
  getAdvanceBonusExtendRender,
} from '../config';

const { New, Details } = AppRoutes.Profile.Advances;

export const Advances = () => {
  const mobile = isMobile();
  const navigate = useNavigate();
  const month = usePaymentMonth();
  const { userData, isCompanyOwner } = useOutletContext<OutletContext>();

  const { currentData: payout, ...payoutProps } = useListQuery(
    {
      id: String(userData?.id),
      month,
      types: JSON.stringify([PayoutType.Advance, PayoutType.PrepaidAdvance]),
    },
    { skip: !userData?.id }
  );

  const { debounceQuery, ...search } = useSearchQuery();
  const filteredData = useFilter<Payout>({
    data: payout || [],
    query: debounceQuery,
    paths: ['event.name', 'amount', 'notes'],
  });

  const [remove, mutation] = useDeleteMutation();
  handleMutation({
    ...mutation,
    successMessage: `Advance ${Messages.DELETED_SUCCESSFULLY}`,
  });

  const { visibleData, ...showMoreProps } = useShowMore(filteredData);

  return (
    <TransactionsList
      {...getCommonListProps(filteredData)}
      createPath={New}
      title="Advances"
      data={visibleData}
      isFooterCreateButton
      cellsMobile={advanceBonusCellsMobile}
      createTitle={isCompanyOwner ? 'New advances' : undefined}
      template={isCompanyOwner ? '1fr 3fr 1fr 1fr 1fr 184px' : undefined}
      listProps={{ ...mapQuery(payoutProps), ...search, ...showMoreProps }}
      onClick={(e, value) =>
        navigate(generatePath(Details, { advanceId: value.id?.toString() }))
      }
      extendRender={getAdvanceBonusExtendRender({
        mobile,
        remove,
        isCompanyOwner,
        type: PayoutType.Advance,
      })}
    />
  );
};
